import authHeader from "../../../authentication/authservices/auth-header";
import apiClient from "../../../http-common";

export const saveNursingCarePlan = (saveObj) => {
  return apiClient.post(`/clinicalCareChart/saveNursingCarePlan`, saveObj, {
    headers: authHeader(),
  });
};

export const getNursingCarePlan = (postObj) => {
  return apiClient.post(`/clinicalCareChart/getNursingCarePlan`, postObj, {
    headers: authHeader(),
  });
};

export const getNursingCarePlanMasterData = (planType) => {
  return apiClient.get(
    `/nursingMaster/getNursingCarePlanMasterData/${planType}`,
    {
      headers: authHeader(),
    },
  );
};
